/**
 * @Author: v_jppjpeng
 * @Date: 2023-11-17 10:46:59
 * @Explain: 卡片组件 - 容器
 */

import { CSSProperties } from 'react';
import classNames from 'classnames';

type PropsType = {
  className?: string;
  children: React.ReactNode;
  title?: string;
  style?: CSSProperties;
};
function CardContainer(props: PropsType) {
  const { className, children, title, style } = props;

  const onClassName = (val: string) => `t-card-container${val}`;

  return (
    <div
      className={classNames('default-card-container', className)}
      style={style}
    >
      {title && (
        <div className={onClassName('__header')}>
          <h1 className={onClassName('__title')}>{title}</h1>
        </div>
      )}
      {children}
    </div>
  );
}

export default CardContainer;
